import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IInviteBuyerUserRepository } from 'application/repositorySchemas/IInviteBuyerUserRepository';
import { type IInviteBuyerUserClient } from 'interfaceAdapter/gatewaySchemas/IInviteBuyerUserClient';

@injectable()
export class InviteBuyerUserRepository implements IInviteBuyerUserRepository {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IInviteBuyerUserClient')
        public readonly inviteBuyerUserClient: IInviteBuyerUserClient,
    ) {}

    public async post(email: string) {
        const { data, message } = await this.inviteBuyerUserClient.post({
            token: this.buyerUserToken.get() || '',
            email,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
